export default "__VITE_ASSET__B_23dAsd__"